import React, { FC, CSSProperties } from "react";
type textProps = {
  id?: string;
  style?: CSSProperties;
  value: string | undefined;
  onChange: (id: string, value: string) => void;
  className?: string;
  placeHolder?: string;
  defaultValue?: string;
  rows?: number;
  cols?: number;
};

const TextArea: FC<textProps> = ({
  id,
  style,
  value,
  onChange,
  className,
  placeHolder,
  defaultValue,
  rows,
  cols,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value;
    onChange?.(id as string, inputValue);
  };

  return (
    <textarea
      id={id}
      style={style}
      rows={rows}
      cols={cols}
      value={value ?? defaultValue}
      onChange={handleChange}
      className={className}
      placeholder={placeHolder}
    />
  );
};

export default TextArea;
